import HTTP from '../../Infra/Http'

// Plant Groups
export const createPlantGroup = async (name, description, image, language='fa') => {
  return await HTTP.Post('/api/plants/admin/group/', { name, description,image,language });
};

export const getAllPlantGroups = async () => {
  return await HTTP.Get('/api/plants/admin/group');
};

export const updatePlantGroup = async (id, groupData) => {
  return await HTTP.Put(`/api/plants/admin/group/${id}`, groupData);
};

export const deletePlantGroup = async (id) => {
  return await HTTP.Delete(`/api/plants/admin/group/${id}`);
};



// Create a new plant
export const createPlant = async (plantData) => {
  return await HTTP.Post('/api/plants/admin/plant', plantData);
};

// Update an existing plant by ID
export const updatePlant = async (id, plantData) => {
  return await HTTP.Put(`/api/plants/admin/plant/${id}`, plantData);
};

// Delete a plant by ID
export const deletePlant = async (id) => {
  return await HTTP.Delete(`/api/plants/admin/plant/${id}`);
};

// get all plants with no Cache
export const getAllPlants = async () => {
  return await HTTP.Get('/api/plants/admin/plants');
};